<template>
  <card dis-hover class="normal-card">
    <div class="card-header">
      <div class="card-header__title">
        <icon class="ms-help" size="16" :type="icon"></icon>
        <span class="ms-help card-header__title-text">
          {{ title }}
        </span>
      </div>
    </div>
    <div class="normal-card__content">
      <slot />
    </div>
  </card>
</template>

<script>
export default {
  props: ['icon', 'title']
}
</script>

<style lang="less">
.normal-card {
  font-size: 12px;
}
</style>
